import type React from "react";
import "./AnswerQuestionsBlock.scss";
import AnswerQuestionsItem from "./AnswerQuestionsItem";

type Props = {
	qa: {
		question: string;
		answer: string;
	}[];
};

const AnswerQestionsBlock: React.FC<Props> = ({ qa }) => {
	return (
		<div className="question-answer-container">
			{qa?.map(({ question, answer }, index) => {
				return (
					<AnswerQuestionsItem
						key={index + question}
						question={question}
						answer={answer}
						index={index}
					/>
				);
			})}
		</div>
	);
};

export default AnswerQestionsBlock;
